import styled from "styled-components";
import { desktop, tablet } from "./BreakPoints";


export const ResponsiveGrid = styled.div<{rowGap?:number, columnGap?:number}>`
    display: grid;

    row-gap: ${props => props.rowGap || 0}px;
    column-gap: ${props => props.columnGap || 0}px;
    
    grid-template-columns: repeat(12, minmax(0, 1fr));
`;

export const ResponsiveGridItem = styled.div<{
    desktop: number;
    tablet?: number;
    mobile?: number;
}>`
    grid-column: span ${props => props.desktop};

    @media (max-width: ${desktop}px) {
        grid-column: span ${props => props.tablet ?? props.desktop};
    }

    @media (max-width: ${tablet}px) {
        grid-column: span ${props =>
            props.mobile ?? props.tablet ?? props.desktop};
    }
`;